// TODO: delete "@ts-nocheck" after typing this file
// @ts-nocheck

import { createApp } from "vue";
import App from "./HighlightsWidget.vue";
import ErrorHandler from "@/common/services/ErrorHandler/ErrorHandler";
import splitTest from "../common/splitTest";
import { init as analytics } from "../common/analytics";
import { waitContainerLoad } from "../common/waitContainerLoad";
import TouchEvents from "../common/touchevents";
import widgetTypes from "@/common/consts/widgetTypes.js";

import "intersection-observer";
import { initDevMode } from "@/dev/dev.init";

new ErrorHandler().init();

const widgetStart = (performance && performance.now()) || null;

let isInitialized = false;
let settings = null;

window.frisbuy = window.frisbuy || {};
window.frisbuy.widgets = window.frisbuy.widgets || {};

window.frisbuy.widgets.stories = {
  init(widgetId) {
    const { settings: settingsData, data } = window.frisbuy[widgetId];
    const { splitTest: settingsSplitTest } = settingsData;

    const initWidget = () => {
      if (window.frisbuy[widgetId].blockInitWidget || isInitialized) {
        return;
      }

      isInitialized = true;

      waitContainerLoad(
        settings.widget.widgetContainerSelector || ".frisbuy-stories-widget",
        (widgetContainer) => {
          const albumsWithPosts = data.albums
            .filter((album) => album.posts.length > 0)
            .sort((a, b) => {
              const { stories_highlights_order: order } = settings;

              if (order.indexOf(String(a.id)) < order.indexOf(String(b.id))) {
                return -1;
              }

              if (order.indexOf(String(a.id)) > order.indexOf(String(b.id))) {
                return 1;
              }

              return 0;
            })
            .map((album) => {
              if (album.coverUrl) {
                // eslint-disable-next-line no-param-reassign
                album.coverUrl = `${album.coverUrl}?cache=${String(
                  Math.random()
                ).slice(2, -1)}`;
              }

              // eslint-disable-next-line no-param-reassign
              album.isAllStoriesWatched = false;

              return album;
            });

          const propsData = {
            propSettings: settings,
            albums: albumsWithPosts,
          };

          const storyWidget = createApp(App, propsData)
            .use(TouchEvents)
            .mixin(mixin);

          storyWidget.config.productionTip = false;

          window.frisbuy[widgetId].widgetElement = storyWidget;

          storyWidget.mount(widgetContainer);
        }
      );
    };

    settings = settingsData;
    settings.widgetType = widgetTypes.HIGHLIGHT;

    if (!data || !data.albums || !data.albums.length) return;

    analytics(settings);

    settings.widgetStart = widgetStart;

    if (settingsSplitTest && settingsSplitTest.name) {
      window.frisbuy[widgetId].blockInitWidget = true;

      // BUG: WFT is this "if"?
      if (
        splitTest.getTestGroup(
          settingsSplitTest.name,
          settingsSplitTest.groups,
          settingsSplitTest.firstEntryAttrs,
          settings.srcDomain,
          (groupName, groupAttributes) => {
            let dimensionId = settingsSplitTest.dimensionId;

            dimensionId = dimensionId || 22;

            if (
              settingsSplitTest.settings &&
              groupName in settingsSplitTest.settings
            ) {
              settings.widget = {
                ...settings.widget,
                ...settingsSplitTest.settings[groupName].widget,
              };
            }

            const hideWidget =
              groupName === "hide" ||
              (settings.widget.hide && settings.widget.hide == 1);

            if (groupAttributes && groupAttributes.excludeFromTest) {
              if (!hideWidget) {
                window.frisbuy[widgetId].blockInitWidget = false;
                initWidget();
              }
            } else if (dimensionId) {
              // GA4
              splitTest.setGroupNameInGa(
                "SR",
                settings.customerCode,
                settingsSplitTest.name,
                groupName,
                {
                  frisbuyTrackerId: settings.analytics.ga4.frisbuyTrackerId,
                  clientTrackerId: settings.analytics.ga4.clientTrackerId,
                  embed_id: settings.embedId,
                  sku_id: settings.skuId,
                  skug_id: settings.groupId,
                  category_id: settings.categoryId || null,
                },
                dimensionId,
                () => {
                  if (!hideWidget) {
                    window.frisbuy[widgetId].blockInitWidget = false;
                    initWidget();
                  }
                }
              );

              // YM
              splitTest.sendYMSplitTestEvent(
                settings.analytics.ym.clientCounterId,
                settingsSplitTest.name,
                groupName,
                {
                  embedId: settings.embedId,
                  skuId: settings.skuId,
                  skuGroupId: settings.groupId,
                  categoryId: settings.categoryId || null,
                },
                () => {}
              );
            } else {
              splitTest.setGroupNameInGa(
                "SR",
                settings.customerCode,
                settingsSplitTest.name,
                groupName,
                {
                  frisbuyTrackerId: settings.analytics.ga4.frisbuyTrackerId,
                  clientTrackerId: settings.analytics.ga4.clientTrackerId,
                  embed_id: settings.embedId,
                  sku_id: settings.skuId,
                  skug_id: settings.groupId,
                  category_id: settings.categoryId || null,
                }
              );

              // YM
              splitTest.sendYMSplitTestEvent(
                settings.analytics.ym.clientCounterId,
                settingsSplitTest.name,
                groupName,
                {
                  embedId: settings.embedId,
                  skuId: settings.skuId,
                  skuGroupId: settings.groupId,
                  categoryId: settings.categoryId || null,
                },
                () => {}
              );

              if (!hideWidget) {
                window.frisbuy[widgetId].blockInitWidget = false;
                initWidget();
              }
            }
          }
        )
      );
    }

    initWidget();
  },
};

const mixin = {
  data() {
    return {
      errorIndex: 0,
    };
  },
  computed: {
    isRetina() {
      return window.devicePixelRatio > 1;
    },
  },

  methods: {
    imageURL(source, isStandardLow, getHighResolution) {
      const { isRetina } = this;

      if (!source) return;

      if (isStandardLow) {
        return isRetina || getHighResolution
          ? {
              imageLowRes: source.imageUrl,
              imageHighRes: source.imageHighResolutionUrl,
            }
          : { imageLowRes: source.thumbnailUrl, imageHighRes: source.imageUrl };
      } else {
        return isRetina || getHighResolution
          ? { imageLowRes: source.thumbnailUrl, imageHighRes: source.imageUrl }
          : {
              imageLowRes: source.thumbnailUrl,
              imageHighRes: source.thumbnailUrl,
            };
      }
    },
  },
};

if (process.env.NODE_ENV === "development") {
  initDevMode();
}
